import { jsx as r, jsxs as _ } from "react/jsx-runtime";
import { Popover as le, Select as de } from "antd";
import * as a from "react";
import { useRef as M, useEffect as m, forwardRef as fe, useState as x, useMemo as z, useImperativeHandle as ue, useCallback as h } from "react";
import { Loader as he, IconContainer as A } from "@biron-data/react-components";
import me from "./OptionList.js";
import { u as p } from "../../../styled-components.browser.esm-BFmoFexH.js";
import { F as pe } from "../../../ChevronDownIcon-CUajCkYx.js";
import { g as we } from "../../../useResizeDetector-sfyDtky2.js";
import { useLanguageResolver as ge } from "@biron-data/react-contexts";
const ve = (e) => {
  const n = M();
  return m(() => {
    n.current = e;
  }), n.current;
};
function xe(e, n) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: n
  }, e), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 4v16m8-8H4"
  }));
}
const be = a.forwardRef(xe);
function $e(e, n) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: n
  }, e), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  }));
}
const ke = a.forwardRef($e);
function ye(e, n) {
  return /* @__PURE__ */ a.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: n
  }, e), /* @__PURE__ */ a.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18L18 6M6 6l12 12"
  }));
}
const Le = a.forwardRef(ye);
var Re = /* @__PURE__ */ ((e) => (e.MULTIPLE = "multiple", e.TAGS = "tags", e))(Re || {});
const Te = fe(({
  mode: e,
  size: n,
  withBackground: F = !0,
  isSimpleInput: d = !1,
  loading: I = !1,
  value: W,
  options: b,
  placement: ee,
  placeholder: D,
  placementOverride: $,
  trigger: te = "click",
  onApply: k,
  onChange: O,
  onClear: y,
  onVisibilityChange: L,
  disabled: H,
  allowMultipleSelection: N = !0,
  style: re,
  onSelectionChange: R,
  getPopupContainer: ne,
  onPaginationChange: T,
  onSearch: G,
  onFocus: K,
  onBlur: s
}, oe) => {
  const w = ge(), [o, E] = x(!1), U = ve(o), [c, j] = x(), [C, X] = x(!1), [f, q] = x(ee), [J, se] = x({
    width: 0
  }), l = M(), Q = M(), i = M(), S = z(() => D ?? {
    add: w.get("configuration-add-value"),
    search: w.get("configuration-search-value")
  }, [w, D]);
  ue(
    oe,
    () => ({
      focus() {
        i.current.focus();
      },
      blur() {
        i.current.blur();
      }
    }),
    []
  );
  const P = h((t) => {
    t.keyCode === 13 && (s == null || s(), E(!1));
  }, [s]);
  m(() => (document.addEventListener("keydown", P), () => {
    document.removeEventListener("keydown", P);
  }), [P]), m(() => {
    !o && U && (s == null || s());
  }, [o, s, U]), m(() => {
    c && c !== "" && !o && E(!0);
  }, [o, c]), m(() => {
    c !== void 0 && G(c);
  }, [G, c]);
  const g = h((t) => {
    E(t), L == null || L(t), !t && b.length > 0 && (k == null || k(), j(""));
  }, [k, L, b.length]), V = h((t, u) => {
    O(t, u), N || g(!1), i && i.current && i.current.focus();
  }, [N, g, O]), Y = h((t, u) => {
    const v = l.current.getElementsByClassName("ant-select-selector");
    v.length > 0 && v[0].dispatchEvent(new MouseEvent("mousedown", {
      bubbles: !0
      // Allow the event to bubble up through the DOM tree
    })), V(t, u);
  }, [V]), ie = z(() => {
    var t;
    return (
      // eslint-disable-next-line react/no-find-dom-node
      /* @__PURE__ */ r(
        Se,
        {
          $selectwidth: ["bottom", "top"].includes(f) && l.current ? (t = l.current) == null ? void 0 : t.getBoundingClientRect().width : void 0,
          children: /* @__PURE__ */ r(he, { className: "edit", loading: I, children: /* @__PURE__ */ r(
            me,
            {
              options: b,
              search: c,
              pagination: {
                offset: 1,
                pageSize: 20
              },
              onPaginationChange: T,
              onSelect: Y
            }
          ) })
        }
      )
    );
  }, [f, I, b, c, T, Y]);
  m(() => {
    var t;
    if (l.current && $) {
      const u = ((t = l.current) == null ? void 0 : t.getBoundingClientRect().y) < 360 ? "bottom" : "top", v = $ ? $(u) : u;
      v !== f && q(v);
    } else window.innerWidth < 750 && f !== "bottom" && q("bottom");
  }, [f, $]);
  const Z = h(() => {
    o ? C || E(!1) : s == null || s();
  }, [C, o, s]), ce = z(() => /* @__PURE__ */ r("div", { ref: l, children: /* @__PURE__ */ r(
    Ce,
    {
      $withbackground: F ? 1 : 0,
      $issimpleinput: d ? 1 : 0,
      $isvisible: o ? 1 : 0,
      ref: i,
      $size: n,
      disabled: H,
      mode: e,
      virtual: !1,
      onDropdownVisibleChange: (t) => {
        Q.current = t;
      },
      autoClearSearchValue: !1,
      searchValue: c,
      onFocus: K,
      onBlur: Z,
      onSearch: (t) => {
        t === "" ? Q.current && j("") : j(t);
      },
      dropdownStyle: { display: "none" },
      onMouseDown: (t) => {
        t.stopPropagation();
      },
      ...e === "multiple" ? {
        allowClear: { clearIcon: /* @__PURE__ */ r(A, { children: /* @__PURE__ */ r(Le, {}) }) },
        placeholder: w.get("configuration-add-value"),
        onChange: (t) => {
          i && i.current && i.current.focus(), R == null || R(t);
        },
        onClear: () => {
          i && i.current && i.current.focus(), y == null || y();
        },
        value: W
      } : {
        showSearch: !0,
        placeholder: /* @__PURE__ */ _(Ee, { children: [
          /* @__PURE__ */ _(B, { $issimpleinput: d ? 1 : 0, children: [
            d ? void 0 : /* @__PURE__ */ r(Me, { children: o ? /* @__PURE__ */ r(ke, { style: { fontSize: "18px" } }) : /* @__PURE__ */ r(be, { style: { fontSize: "18px" } }) }),
            /* @__PURE__ */ r(B, { $issimpleinput: d ? 1 : 0, children: o ? S.search : S.add })
          ] }),
          d ? /* @__PURE__ */ r(A, { color: "var(--border-color-base)", size: 14, children: /* @__PURE__ */ r(pe, {}) }) : void 0
        ] }),
        allowClear: o,
        onClear: () => j("")
      }
    }
  ) }), [F, d, o, n, H, e, c, K, Z, w, W, S.search, S.add, R, y]), ae = h((t) => {
    t ? g(!0) : C || g(!1);
  }, [g, C]);
  return we(l, J, (t) => {
    se({
      width: t
    });
  }), /* @__PURE__ */ r(
    je,
    {
      style: re,
      onMouseLeave: () => {
        X(!1);
      },
      onMouseEnter: () => {
        X(!0);
      },
      children: /* @__PURE__ */ r(
        le,
        {
          placement: f,
          trigger: te,
          overlayClassName: "box-overlay",
          onOpenChange: ae,
          open: o,
          content: ie,
          overlayInnerStyle: {
            minWidth: J.width
          },
          getPopupContainer: ne,
          children: ce
        }
      )
    }
  );
}), Ee = p.div`
    display: flex;
    align-items: center;
`, je = p.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`, Ce = p(de)`
    /* force antd select to be smaller than everywhere else */

    &&& {
        display: ${(e) => e.$withbackground ? "inherit" : "flex"};
        height: 100%;
        max-height: 100%;
        width: 100%;
        line-height: 20px;

        ${({ $issimpleinput: e }) => e ? "" : `border: 1px solid var(--border-color-base);
    border-radius: var(--main-border-radius);`}
        ${({ $isvisible: e, $issimpleinput: n }) => e && !n ? "min-width: 300px;" : ""}
        .ant-select-clear {
            background-color: transparent;
            color: var(--light-grey);
        }
    }

    &&& .ant-select-selector {
        background: ${(e) => e.$withbackground ? "white" : "transparent"};
        width: 100%;
        ${({ size: e }) => e === "small" ? "min-height: 32px;" : ""}
    }

    &&& .ant-select-arrow {
        display: none;
    }

    ${({ $isvisible: e }) => e ? "" : `&&:hover * {
      color: var(--primary);
  }`}
    &&& .ant-select {
        line-height: 20px;
    }

    &&& .ant-select-selection-item {
        height: 24px;
        line-height: 24px;
    }

    &&& .ant-select-selector input {
        cursor: ${({ $isvisible: e }) => e ? "text" : "pointer"} !important;
        color: ${({ $isvisible: e }) => e ? "var(--medium-grey)" : ""} !important;
    }
`, Se = p.div`
    min-width: ${(e) => e.$selectwidth ? `${e.$selectwidth}px` : "unset"}
`, B = p.div`
    color: ${(e) => e.$issimpleinput ? "inherit" : "rgb(89, 89, 89)"};
    height: 100%;
    display: flex;
    width: 100%;
    justify-content: space-between;
`, Me = p.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 18px;
    margin-right: 11px;
`;
export {
  Re as Mode,
  Te as MultipleSelectWithOptionList
};
//# sourceMappingURL=MultipleSelectWithOptionList.js.map
